// extracted by mini-css-extract-plugin
export var cardIcon = "_6d-5";
export var cardIconUnframed = "_6d-9";
export var checkboxCard = "_6d-0";
export var checkboxCardSelected = "_6d-4";
export var disabled = "_6d-2";
export var interactive = "_6d-1";
export var outerBorder = "_6d-3";
export var spacerMedium = "_6d-8";
export var spacerSmall = "_6d-7";
export var spacerXsmall = "_6d-6";